import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
	public showPass: boolean = false
	@Input() form: FormGroup = new FormGroup(Input())
	@Input() id?: string
	@Input() name: string | number | null = ''
	@Input() placeholder?: string
	@Input() max?: number = 50
	@Input() typeInput?: string = 'text'
	@Input() labelName?: string
	@Input() callout?: string
	@Input() inputModel: any
	@Input() inputMask: string = ''
    @Input() allowCnpj: boolean = false
    // @Input() inputAltMask?: any = {
    //     mask: '',
    //     digits: 0,
    //     oldMask: this.inputMask
    // }
	@Input() showLabel: boolean = false
	@Input() disabled: boolean = false
	@Output() emmitEvent: EventEmitter<any> = new EventEmitter()
	@Output() emmitBlur: EventEmitter<any> = new EventEmitter()

	constructor() {}

	ngOnInit(): void {}

	toggleInputPass(): void {
		this.showPass = !this.showPass
	}

    // changeMask(evt: any): void {
    //     if(this.inputAltMask?.mask !== '' && this.inputAltMask?.digits > 0) {
    //         if(this.form?.controls?.registrationNumberCFPorCNPJ?.value?.length > this.inputAltMask?.digits) {
    //             this.inputMask = this.inputAltMask?.mask

    //         }
    //         else {
    //             this.inputMask = this.inputAltMask?.oldMask
    //         }

    //     }
    // }
    public isCnpjMode: boolean = false
    public isCpfMode: boolean = false

    changeMask(evt: any): void {
        const isRegistrationField =
            this.name === 'registrationNumber' ||
            this.name === 'registrationNumberCFPorCNPJ'

        if (!isRegistrationField) {
            return
        }
        let value = (evt.target.value || '').toUpperCase()
        evt.target.value = value
        // Se NÃO permitir CNPJ, mantém somente CPF
        if (!this.allowCnpj) {
            this.inputMask = '000.000.000-00'
            this.isCpfMode = true
            this.isCnpjMode = false
            return
        }
        const clean = value.replace(/[.\-\/]/g, '')
        this.isCpfMode = false
        this.isCnpjMode = false

        if (!clean.length) {
            this.inputMask = ''
            return
        }
        if (clean.length < 5) {
            this.inputMask = 'AAAAAAAAAAAAAA'
            return
        }
        // Possui letra = CNPJ alfanumérico
        if (/[A-Z]/.test(clean)) {
            this.isCnpjMode = true
        }
        else {
            // Mais de 11 números = CNPJ
            if (clean.length > 11) {
                this.isCnpjMode = true
            }
            else {
                const fifthChar = clean[4]
                // 5º caractere letra = CNPJ
                if (/[A-Z]/.test(fifthChar)) {
                    this.isCnpjMode = true
                }
                else {
                    this.isCpfMode = true
                }
            }
        }
        if (this.isCpfMode) {
            this.inputMask = '000.000.000-00'
        }

        if (this.isCnpjMode) {
            this.inputMask = 'AA.AAA.AAA/AAAA-00'
        }
    }
    keyDownHandler(evt: any): void {
        // ===== EMAIL =====
        if (this.typeInput === 'email') {
            if (/[^a-zA-Z0-9@._+-]/gi.test(evt.key)) {
                evt.preventDefault()
            }

            return
        }

        // ===== CPF/CNPJ =====
        const isRegistrationField =
            this.name === 'registrationNumber' ||
            this.name === 'registrationNumberCFPorCNPJ'

        if (
            this.typeInput === 'text' &&
            isRegistrationField
        ) {
            if (!this.allowCnpj) {
                this.isCpfMode = true
                this.isCnpjMode = false
                this.inputMask = '000.000.000-00'
                return
            }
            const value = (evt.target.value || '')
                .replace(/[.\-\/]/g, '')

            // Se já estiver em CPF e digitar o 12º número troca automaticamente para CNPJ
            if (
                this.isCpfMode &&
                value.length === 11 &&
                /\d/.test(evt.key)
            ) {
                this.isCpfMode = false
                this.isCnpjMode = true
                this.inputMask = 'AA.AAA.AAA/AAAA-00'
            }

            // Bloqueia caracteres especiais inválidos
            if (/[`~!#$%^&*()_|+=?;:'",<>\{\}\[\]\\]/gi.test(evt.key)) {
                evt.preventDefault()
            }

            return
        }

        // ===== CAMPOS TEXT NORMAIS =====
        if (this.typeInput === 'text') {
            if (/[`~!#$%^*_=+\[\]\\{}<>]/gi.test(evt.key)) {
                evt.preventDefault()
            }
        }
    }

	onChange(event: any, value: string): void {
        this.emmitEvent.emit(value.replace(/[^a-z0-9@._+-]/gi, ''))
    }

	onBlur(event: any, value: string): void {
		if (value.length) this.emmitBlur.emit(value)
	}
}
